import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import React from "react";
import "../Styles/pages/products.scss";
import "../Styles/components/dataTable.scss";
import { Button } from "primereact/button";

function CustomDataTable({
    value = [],
    paginator = false,
    header = "",
    columns = [],
    rows = 20,
    tableClassName = "",
    tableIdName = "",
    rowExpansionTemplate = () => { },
    onRowToggle = () => { },
    children,
    title = "",
    tabs = [],
    setState = () => { },
    setActiveTab,
    expandedRows,
    activeTab,
    loading,
    resetPage = () => { },
    tab = false,
    filters,
    onFilter,
    filterDisplay = "menu",
    tabHeaderAction = null,
    tabBodyContent = null,
    ...arg
}) {
    const { t } = useTranslation("common");

    const tabButtons = tabs.map(({ label }, i) =>
        <Button
            className={`p-button-text plans-table-btn ${activeTab === i ? "p-button-raised p-button-info active active-tabs" : "p-button-plain not-active not-active-tabs"}`}
            label={t(label)}
            key={i}
            onClick={() => {
                setActiveTab(i)
                setState((state) => ({ ...state, page: 0, sort: 'id,desc', first: 0, tab: true }));
                resetPage()
            }}
        />
    );

    const tabHeader = tabHeaderAction ? (
        <>
            <div className="plans-tabs-btn">{tabButtons}</div>
            <div className="plans-tab-header-action-row">{tabHeaderAction}</div>
        </>
    ) : (
        <div className="plans-tabs-btn">{tabButtons}</div>
    );

    const dataTableProps = {
        id: "data_table",
        value,
        paginator,
        breakpoint: "1050px",
        tableStyle: { tableLayout: 'auto' },
        dataKey: "id",
        header: tabs.length > 0 ? tabHeader : header,
        rows,
        className: `p-datatable-responsive-table datatable p-card ${tableClassName}`,
        rowExpansionTemplate,
        onRowToggle,
        expandedRows,
        loading,
        ...arg
    };

    if (filters !== null && filters !== undefined) {
        dataTableProps.filters = filters;
        dataTableProps.filterDisplay = filterDisplay;
        if (onFilter) {
            dataTableProps.onFilter = onFilter;
        }
    }

    const customTabBody = tabs.length > 0 && tabBodyContent ? tabBodyContent(activeTab) : null;

    if (customTabBody) {
        return (
            <>
                {title && <h6 className="title-tile ml-0">{t(title)}</h6>}
                <div
                    id="data_table"
                    className={`p-datatable-responsive-table datatable p-card ${tableClassName}`}
                >
                    <div className="p-datatable-header">{tabHeader}</div>
                    <div className="p-datatable-custom-tab-body">{customTabBody}</div>
                </div>
            </>
        );
    }

    return (
        <>
            {title && <h6 className="title-tile ml-0">{t(title)}</h6>}
            <DataTable {...dataTableProps}>
                {columns?.map(({
                    field = "",
                    body,
                    header = "",
                    sort = false,
                    sortable = sort,
                    style = {},
                    className = "",
                    bodyClassName = "",
                    expander,
                    alignHeader = "left",
                    align = "left",
                    filter = false,
                    filterPlaceholder = "",
                    showFilterMenu = true,
                    ...arg
                }, i) => {
                    const columnProps = {
                        className: `datatable-cell-default ${className}`,
                        field,
                        body,
                        header,
                        alignHeader,
                        align,
                        headerClassName: `datatable-cell-default ${className}`,
                        expander,
                        style: { ...style },
                        bodyClassName,
                        filter,
                        ...arg
                    };

                    if (sortable) {
                        columnProps.sortable = true;
                    }

                    if (filter && filterDisplay === "row" && filters !== null && filters !== undefined) {
                        columnProps.filterPlaceholder = filterPlaceholder;
                        columnProps.showFilterMenu = showFilterMenu;
                    }

                    return <Column key={i} {...columnProps} />;
                })}
                {!!children && children}
            </DataTable>
        </>
    );
}

export default CustomDataTable;